import { formatDate } from "../../helperFunctions";
export const LoanProductCard = ({
  productName,
  creationDate,
  onClick,
}: {
  productName: string;
  creationDate: string;
  onClick: () => void;
}) => {
  return (
    <button
      type="button"
      className="
      p-4 rounded-lg gap-6 cursor-pointer text-left
      w-full bg-light-green-bg border-pry-dark-green-300/10
      flex flex-col justify-between
      transition-all duration-200 hover:scale-95
      "
      onClick={onClick}
    >
      <p className="text-sm font-bold text-pry-green-200">
        {productName ?? "Null"}
      </p>

      <p className="w-full font-medium flex justify-between gap-2 flex-wrap text-xs text-pry-dark-green-300/60">
        <span>Created:</span>
        <span className="text-pry-dark-green-300/70">
          {formatDate(creationDate, "DD MMM, YYYY")}
        </span>
      </p>
    </button>
  );
};
